import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const publisherUserBlackListStatusChangeAction = createAsyncThunk(
    'publisher-user-black-list-status-update',
    async (data, { rejectWithValue }) => {
        try {
            // const res = await axios.put(`/admins/api/blacklist-partner-status-change?p_user_id=${data?.p_user_id}&partner=${data.partner}&publisher_id=${data.publisher_id}&user_id=${data.user_id}`)
            const res = await axios.put(`/admins/api/blacklist-partner-status-change?partner=${data.partner}&user_id=${data.user_id}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const publisherUserBlackListStatusChangeSlice = createSlice({
    name: 'publisher-user-black-list-status-update',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(publisherUserBlackListStatusChangeAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(publisherUserBlackListStatusChangeAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(publisherUserBlackListStatusChangeAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const publisherUserBlackListStatusChangeReducer = publisherUserBlackListStatusChangeSlice.reducer